import { render, staticRenderFns } from "./LoginLayoutComponent.vue?vue&type=template&id=1163f07e&"
import script from "./LoginLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./LoginLayoutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports